import { TD, TH } from "styled/table";

export const TableHeader = ({modalType}) => {
    return (
      <thead className="bg-gray-50">
        <tr className="py-2">
          {modalType!=="tyres" &&
          <TH scope="col"></TH>
}
          <TH scope="col">S.N.</TH>
          <TH scope="col">Stencil Number</TH>
          <TH scope="col">NSD</TH>
          <TH scope="col">Brand</TH>
          <TH scope="col">Size</TH>
          <TH scope="col">Km Travelled</TH>
          <TH scope="col">Current Status</TH>
          {modalType==="tyres" &&
          <TH scope="col">Actions</TH>
}
          <TH scope="col">Cost</TH>
        </tr>
      </thead>
    );
  };